import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LangEnum } from '@models/enums';
import { useAppSelector } from '@store';

export const useVerificationUrl = () => {
    const { i18n } = useTranslation();
    const verificationUrl =
        useAppSelector((state) => state.docsVerification.sdkOptions?.verificationUrl) || '';
    const isCustomPartner = useAppSelector(
        (state) => state.docsVerification.sdkOptions?.customPartner?.concordium,
    );

    const urlWithLang = useMemo(() => {
        if (i18n.language === LangEnum.EN) {
            let url: URL;

            try {
                url = new URL(verificationUrl);
            } catch {
                url = new URL(window.location.href);
            }

            if (isCustomPartner) {
                url.searchParams.set('skipIntro', 'true');
            }

            return url.toString();
        }

        const url = new URL(window.location.href);

        url.searchParams.set('lang', i18n.language);

        if (isCustomPartner) {
            url.searchParams.set('skipIntro', 'true');
        }

        return url.toString();
    }, [i18n.language, verificationUrl, isCustomPartner]);

    return {
        verificationUrl: urlWithLang,
    };
};
